'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  nch5: '/* v1.2.26,1.2.29,1 2018-10-25 10:14:18 */',
  nc: '/* v1.2.26,1.2.29,1 2018-10-25 09:33:12 */'
};